import { NewsletterSignUpLocation } from '@interfaces';

interface GetMailchimpUrlParams {
	email?: string;
	location?: NewsletterSignUpLocation;
	mailchimpFormLocationFieldTag?: string;
	mailchimpListId: string;
	mailchimpTags?: string;
}

export const getMailchimpUrl = ({
	email,
	location,
	mailchimpFormLocationFieldTag,
	mailchimpListId,
	mailchimpTags,
}: GetMailchimpUrlParams) => {
	const actionUrlObject = new URL(
		process.env.NEXT_PUBLIC_MAILCHIMP_HOSTED_FORM_URL ?? '',
	);

	actionUrlObject.searchParams.append('id', mailchimpListId);

	if (mailchimpFormLocationFieldTag && location) {
		actionUrlObject.searchParams.append(
			mailchimpFormLocationFieldTag,
			location,
		);
	}

	if (mailchimpTags) {
		actionUrlObject.searchParams.append('tags', mailchimpTags);
	}

	if (email) {
		actionUrlObject.searchParams.append('EMAIL', email);
	}

	return actionUrlObject.toString();
};
